import { colorsPalettes } from "@similarweb/styles";
import styled from "styled-components";

export const TitleContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    padding: 16px 24px 8px 24px;
    border-bottom: 1px solid ${colorsPalettes.carbon[100]};
`;
